import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .locationName {
    font-weight: 600;
    margin-bottom: 4px;
  }

  .hint {
    font-size: 0.85rem;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 12px;
  }

  .drawing {
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
  }
`;
